import { styled } from '@nykaa/ui-components';

import { resetButton } from 'styles/mixin';

export const Star = styled.button`
  ${resetButton};
  display: flex;
  align-items: center;
  margin-right: ${({ theme }) => theme.spacing.spacing20};
`;
